import { documentReady } from "@sazka/utils/document-ready";
import { handleConsentOverlay } from "@sazka/utils/gdpr/consent-overlay";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";

async function initConsentOverlay() {
    await showConsentOverlay();

    eventBus.on(GlobalEvents.ConsentsChanged, async () => {
        await showConsentOverlay();
    });
}

async function showConsentOverlay() {
    const richTextElements = document.querySelectorAll(".ds-rich-text-video");

    if (!richTextElements) return;

    richTextElements.forEach(async (el) => {
        const element = el as HTMLElement;
        const embedUrl = `//www.youtube-nocookie.com/embed/${element.dataset.videoCode}`;

        const overlayAdded = await handleConsentOverlay(element, embedUrl);
        const videoShown = element.querySelector("iframe");

        if (!overlayAdded && !videoShown) {
            element.insertAdjacentHTML("afterbegin", `<iframe src="${embedUrl}" allowfullscreen></iframe>`);
        }
    });
}

documentReady(() => {
    initConsentOverlay();
});
